import * as types from "./memberIdentifierRecoveryActionTypes";
import api from "./memberIdentifierRecoveryApi";

export function request(model, item, customHeaders, options, query) {
  return {
    type: types.FETCH,
    model,
    promise: api.request(model, item, customHeaders, options, query),
    payload: { model },
  };
}

export function recoverIdentifier(model, item, customHeaders, options, query) {
  return {
    type: types.RECOVER_IDENTIFIER,
    model,
    promise: api.request(model, item, customHeaders, options, query),
  };
}



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryActions.js